import { LoginRequest, AuthTokens } from '../domain/types';
import { AuthApi } from '../infrastructure/authApi';
import { AuthStorage } from '../infrastructure/authStorage';

export class LoginUseCase {
  private authApi: AuthApi;
  private authStorage: AuthStorage;

  constructor() {
    this.authApi = new AuthApi();
    this.authStorage = new AuthStorage();
  }

  async execute(_: LoginRequest): Promise<{ success: boolean; error?: string; errorCode?: string; field?: string; status?: number }> {
    const hudleSessionResponse = await this.authApi.getHudleSessionAccessToken();
    if (!hudleSessionResponse.success || !hudleSessionResponse.accessToken) {
      return {
        success: false,
        error: hudleSessionResponse.error || 'Сессия приложения не найдена',
        errorCode: hudleSessionResponse.errorCode,
        status: hudleSessionResponse.status,
      };
    }

    const response = await this.authApi.sessionLogin(hudleSessionResponse.accessToken);
    if (response.success && response.user && response.tokens && response.tokens.refresh) {
      const tokens: AuthTokens = {
        access: response.tokens.access,
        refresh: response.tokens.refresh,
      };
      this.authStorage.setAuthData(tokens, response.user);
      return { success: true };
    }

    return {
      success: false,
      error: response.error || 'Произошла ошибка',
      errorCode: response.error_code,
      field: response.field,
      status: response.status,
    };
  }
}
